import {
  Box,
  Button,
  Checkbox,
  Flex,
  IconButton,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import Select from "react-select";
import {
  homeworkAbsentReportRequest,
  restrictStuentHomeworkRequest,
} from "../../../modules/admin-modules/reports/Actions";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import { CSVLink } from "react-csv";
import { getAllHomeworksRequest } from "../../../modules/admin-modules/homework/Actions";

const HomeworkAbsentReport = () => {
  const dispatch = useDispatch();
  const [homeworkId, setHomeworkId] = useState("");

  useEffect(() => {
    if (homeworkId) dispatch(homeworkAbsentReportRequest(homeworkId));
  }, [homeworkId]);

  useEffect(() => {
    dispatch(getAllHomeworksRequest());
  }, []);
  const homeworks = useSelector((state) => state.homework.homeworks);
  const homeworkAbsent = useSelector((state) => state.reports.homeworkAbsent);
  const isLoading = useSelector((state) => state.reports.isLoading);

  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const homeworksOptions = homeworks?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const viewData = (data) => {};
  const headers = [
    { label: "name", key: "name" },
    { label: "phone", key: "phone" },
    { label: "parent_phone", key: "parent_phone" },
  ];
  const Data = homeworkAbsent?.map((data, index) => {
    return {
      ...data,

      index: `#${index + 1}`,
      id: data?.id,
      name: data?.name,
      parent_phone: data?.parent_phone,
      phone: data?.phone,
    };
  });

  const suspendAll = () => {
    dispatch(restrictStuentHomeworkRequest(homeworkId));
  };
  const columns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "name",
    },
    {
      Header: " رقم هاتف ولي الامر",
      accessor: "parent_phone",
    },

    {
      Header: " رقم هاتف الطالب",
      accessor: "phone",
    },
  ];

  return (
    <Layout>
      <div style={{ minHeight: "400px" }}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10000000"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            تقرير غياب الواجبات
          </Text>
          <Flex
            w={{ base: "30%", md: "50%" }}
            justifyContent="space-between"
            alignItems="center"
          >
            <Box w="50%">
              <Select
                options={homeworksOptions}
                isMulti={false}
                onChange={(data) => {
                  setHomeworkId(data?.value);
                }}
                styles={colourStyles}
                placeholder="Select Homework"
              />
            </Box>
            <Box
              mx="10px"
              border="1px solid gray"
              borderRadius="8px"
              padding="10px"
            >
              <CSVLink
                headers={headers}
                data={Data?.length != 0 ? Data : []}
                filename={"homework-report.csv"}
                className="btn btn-primary"
                target="_blank"
              >
                Download
              </CSVLink>
            </Box>
            <Button mx="5px" onClick={suspendAll}>
              Restrict All
            </Button>
            <LogoutMenu />
          </Flex>
        </Flex>

        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path={"openModel"}
          Actions
          Title={``}
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={isLoading}
          perPage={size}
          totalPage={Math.ceil(10 / 50)}
        />
      </div>
    </Layout>
  );
};

export default HomeworkAbsentReport;
